import { useQuery } from '@tanstack/react-query';
import { fetchMyPushSubscriptions } from '../api/pushSubscriptions';

const DEFAULT_OPTIONS = {
  staleTime: 30_000,
  gcTime: 5 * 60_000,
};

export function usePushSubscriptionsQuery(options = {}) {
  return useQuery({
    queryKey: ['pushSubscriptions'],
    queryFn: fetchMyPushSubscriptions,
    ...DEFAULT_OPTIONS,
    ...options,
  });
}
